import { useEffect, useState } from 'react'

/** A visible resend delay complements the server's independent abuse limits. */
export function useOtpResend() {
  const [seconds, setSeconds] = useState(0)
  const [availableAt, setAvailableAt] = useState(0)
  useEffect(() => {
    if (!availableAt) return
    // Wall-clock time continues while a mobile browser suspends this tab.
    const timer = window.setInterval(() => {
      const remaining = Math.max(0, Math.ceil((availableAt - Date.now()) / 1000))
      setSeconds(remaining)
      if (remaining === 0) window.clearInterval(timer)
    }, 1000)
    return () => window.clearInterval(timer)
  }, [availableAt])
  return { seconds, start: () => { setSeconds(60); setAvailableAt(Date.now() + 60_000) } }
}
